import { lazy } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { getStudioHref } from '@/lib/hostRouting'
import { lazyWithReload } from '@/lib/lazyWithReload'
import { prefetchDemoPage } from '@/lib/prefetchDemo'
import { prefetchCfoPage } from '@/lib/prefetchCfo'
import RouteRedirect from '@/routes/RouteRedirect'

const LandingPage = lazyWithReload(() => import('@/pages/LandingPage'))
const DemoPage = lazy(prefetchDemoPage)
const CfoPage = lazy(prefetchCfoPage)
const ContactPage = lazyWithReload(() => import('@/pages/ContactPage'))
const BookPage = lazyWithReload(() => import('@/pages/BookPage'))
const PrivacyPage = lazyWithReload(() => import('@/pages/PrivacyPage'))

function RedirectToStudio({ path }) {
  const { search } = useLocation()
  return <RouteRedirect to={getStudioHref(`${path}${search}`)} />
}

export default function PublicRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/cfo" element={<CfoPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/book" element={<BookPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/studio" element={<RedirectToStudio path="/" />} />
      <Route path="/login" element={<RedirectToStudio path="/login" />} />
      <Route path="/admin" element={<RedirectToStudio path="/admin" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
